/* card-promo-video: recién asigna `src` (y por lo tanto dispara la descarga)
   cuando la tarjeta entra en viewport, para no bajar N videos de golpe al
   cargar la colección. Vanilla, sin dependencias -- mismo criterio del
   resto del tema. */
(function () {
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.card-promo-video__video[data-src]').forEach((video) => {
      video.src = video.dataset.src;
      video.play().catch(function () {});
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;

        if (entry.isIntersecting) {
          if (video.dataset.src && !video.src) {
            video.src = video.dataset.src;
          }
          video.play().catch(function () {});
        } else {
          video.pause();
        }
      });
    },
    { rootMargin: '200px 0px' }
  );

  document.querySelectorAll('.card-promo-video__video[data-src]').forEach(function (video) {
    observer.observe(video);
  });
})();
